module.exports = __webpack_public_path__ + "img/294151928.191e9af1.jpg";